import React from 'react';
import ToggleRow from './ToggleRow';

const DeliverySettingsCard = ({ settings, onToggle }) => (
  <div className="bg-white rounded-xl shadow p-6">
    <h3 className="font-semibold mb-4">配送方式</h3>
    <div className="space-y-4">
      <ToggleRow
        label="外送配送"
        description="开启后 H5 用户可选择外送"
        checked={!!settings.enable_delivery}
        onToggle={() => onToggle('enable_delivery')}
      />
      <ToggleRow
        label="到店自提"
        description="开启后 H5 用户可选择到店自提"
        checked={!!settings.enable_pickup}
        onToggle={() => onToggle('enable_pickup')}
        bordered
      />
    </div>
  </div>
);

export default DeliverySettingsCard;